import { render, staticRenderFns } from "./SettingsAccessibility.vue?vue&type=template&id=5f7cc253&"
import script from "./SettingsAccessibility.vue?vue&type=script&lang=js&"
export * from "./SettingsAccessibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports